import {
  createContext,
  useState,
  useCallback,
  useMemo,
  useContext,
  useEffect,
} from "react";
import classnames from "classnames";
import styles from "@/styles/Notification.module.scss";

export const NotificationContext = createContext({
  showNotification: () => null,
  hideNotification: () => null,
});

const initialValue = { message: null, props: {} };
export function NotificationProvider({ children }) {
  const [notification, setNotification] = useState(initialValue);

  const showNotification = useCallback((message, props = {}) => {
    setNotification({ message, props });
  }, []);

  const hideNotification = useCallback((props = {}) => {
    setNotification({ ...initialValue, props });
  });

  const contextValue = useMemo(
    () => ({ showNotification, hideNotification }),
    []
  );

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
      <Notification message={notification.message} {...notification.props} />
    </NotificationContext.Provider>
  );
}

export default function Notification({ message, time = 5000, caution, fixed }) {
  const { hideNotification } = useContext(NotificationContext);

  const handleClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  useEffect(() => {
    let hideTimeoutId;
    if (message && !fixed) {
      hideTimeoutId = setTimeout(() => {
        hideNotification();
      }, time);
    }
    return () => {
      clearTimeout(hideTimeoutId);
    };
  }, [message]);

  return (
    <div
      className={classnames(styles.notification, {
        [styles.show]: !!message,
        [styles.caution]: caution,
      })}
    >
      {message && (
        <div className={styles.inner} onClick={handleClick}>
          {message}
        </div>
      )}
    </div>
  );
}
